import 'core-js/stable'; // polyfills
import 'regenerator-runtime/runtime';

import('./bootstrap');
/* 
async boundary. splits out the initialization code of a larger chunk to avoid any additional round trips and improve performance. 
See here for more info: https://webpack.js.org/concepts/module-federation/#troubleshooting
*/
